// src/hooks/usePlanGuard.js
// CLAUDE.md "5. 플랜·크레딧 시스템"의 단일 진실 원천.
// 새로운 플랜 기능은 반드시 이 훅을 통해서만 게이팅한다.

import { useMemo } from 'react';
import { useAuth } from './useAuth.js';

export const PLAN_CONFIG = {
  free:  { credits: 0,   watermark: true,  comment: false, emotion: false, priority: false, crossBorder: false, logo: false },
  tier1: { credits: 15,  watermark: true,  comment: false, emotion: false, priority: false, crossBorder: false, logo: false },
  tier2: { credits: 60,  watermark: false, comment: true,  emotion: true,  priority: false, crossBorder: false, logo: false },
  tier3: { credits: 150, watermark: false, comment: true,  emotion: true,  priority: true,  crossBorder: true,  logo: true  },
};

function isAdminEmail(email) {
  const list = (import.meta.env.VITE_ADMIN_EMAILS || '')
    .split(',')
    .map((s) => s.trim().toLowerCase())
    .filter(Boolean);
  return list.includes((email || '').toLowerCase());
}

export function usePlanGuard() {
  const { profile } = useAuth();
  const admin = isAdminEmail(profile?.email);
  const plan = admin ? 'tier3' : (profile?.plan ?? 'free');
  const credits = profile?.credits ?? 0;

  return useMemo(() => {
    const cfg = PLAN_CONFIG[plan] ?? PLAN_CONFIG.free;
    return {
      plan,
      credits,
      isAdmin:                 admin,
      monthlyCredits:          cfg.credits,
      hasWatermark:            admin ? false : cfg.watermark,
      canAddCustomComment:     cfg.comment,
      canSelectEmotionTone:    cfg.emotion,
      canPriorityRender:       cfg.priority,
      canCrossBorderTranslate: cfg.crossBorder,
      canAddChannelLogo:       cfg.logo,
      canRemoveWatermark:      !cfg.watermark,
    };
  }, [plan, credits, admin]);
}
